<div class="modal-header">
    <h4 class="modal-title">{{ modalTitle }}</h4>
</div>
<div class="modal-body">
    <ng-container *ngIf="!isResetScreen; else resetContent">
        <cm-message-block *ngIf="showFileError" class="file-error" type="error">
            <div>
                <p class="file-restriction">Uploaded image should meet the following requirements:</p>
                <p class="file-restriction">min size: 144x144pxl;</p>
                <p class="file-restriction">max weight: 3MB;</p>
                <p class="file-restriction">format: jpg, jpeg, png;</p>
            </div>
        </cm-message-block>
        <cm-file-upload
            *ngIf="!imageFile && !defaultConfiguration?.originalFile"
            (change)="onFilesChange($event)"
            [showFilesList]="false"
            [maxSize]="maxLogoFileSize"
            [allowedTypes]="allowedTypes"
            class="file-upload"
        >
        </cm-file-upload>
        <cm-image-cropper
            class="cropper"
            *ngIf="imageFile || defaultConfiguration?.originalFile"
            [allowSwitchingMode]="allowSwitchingMode"
            [availableModes]="availableModes"
            [options]="cropperOptions"
            [defaultConfiguration]="defaultConfiguration"
            [imageFile]="imageFile"
            (imageLoaded)="imageLoaded()"
            (imageCropped)="imageCropped($event)"
        >
        </cm-image-cropper>
    </ng-container>
    <ng-template #resetContent>
        <span>{{ resetScreenMessage }}</span>
    </ng-template>
</div>
<div class="modal-footer">
    <ng-container *ngIf="!isResetScreen; else resetScreenFooter">
        <div class="button-container">
            <button
                *ngIf="defaultConfiguration && isResetAvailable"
                class="btn btn-default"
                (click)="setResetScreenMode()"
            >
                reset
            </button>
        </div>
        <div class="button-container">
            <button *ngIf="!imageFile" class="btn btn-default" (click)="cancel()">cancel</button>
            <button *ngIf="imageFile" class="btn btn-default" (click)="back()">back</button>
            <button *ngIf="imageFile" class="btn btn-primary" (click)="submit(UPLOAD_IMAGE_ACTION.UPLOAD)">
                submit
            </button>
            <button *ngIf="imageFile" class="btn btn-default" (click)="cancel()">cancel</button>
            <button
                *ngIf="defaultConfiguration?.originalFile"
                class="btn btn-primary"
                (click)="submit(UPLOAD_IMAGE_ACTION.EDIT)"
            >
                save
            </button>
        </div>
    </ng-container>
    <ng-template #resetScreenFooter>
        <div></div>
        <div class="button-container">
            <button class="btn btn-default" (click)="backToEdit()">back</button>
            <button class="btn btn-primary" (click)="reset()">Confirm</button>
        </div>
    </ng-template>
</div>
